import { THEME_KEYS } from "@/constants/config";
import { cn } from "@/lib/utils";
import { usePreferences } from "@/providers/preferences-provider";
import { Monitor, Moon, Sun } from "lucide-react";

const ORDER = [THEME_KEYS.light, THEME_KEYS.dark, THEME_KEYS.system] as const;

const ICONS = {
  [THEME_KEYS.light]: Sun,
  [THEME_KEYS.dark]: Moon,
  [THEME_KEYS.system]: Monitor,
} as const;

export const ThemeToggle = ({ className }: { className?: string }) => {
  const { theme, setTheme } = usePreferences();

  return (
    <div className={cn("inline-flex items-center rounded-lg border border-border p-0.5", className)}>
      {ORDER.map((key) => {
        const Icon = ICONS[key];
        return (
          <button
            key={key}
            type="button"
            aria-label={`${key} theme`}
            aria-pressed={theme === key}
            onClick={() => setTheme(key)}
            className={cn(
              "rounded-md p-1.5 transition-colors",
              theme === key ? "bg-muted text-foreground" : "text-muted-foreground hover:text-foreground",
            )}
          >
            <Icon className="size-4" aria-hidden />
          </button>
        );
      })}
    </div>
  );
};
